import * as React from 'react';
import { ComponentProps } from 'ui';
import { MdShare } from 'react-icons/md';
import { withOpenState, OpenStateInjectedProps } from 'ui/common/enhancers/with-open-state';
import { SharedState } from 'app/types-shared';
import { routeConstants } from 'app/routes/route-constants';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { LinkToModalView } from 'ui/link-to-modal-view/link-to-modal-view';

interface ShareLinkButtonTranslations {
  textHeaderTitle?: string;
  textHeaderInfo?: string;
  textDone?: string;
  textNoUserEmailExist?: string;
  textGoToProfile?: string;
}
interface ShareLinkButtonComponentProps {
  sharedState?: SharedState;
  searchRequired?: boolean;
}

export const ShareLinkContext = React.createContext({searchRequired: false, domainNoUsers: undefined});

export type ShareLinkButtonProps = ComponentProps & OpenStateInjectedProps & ShareLinkButtonComponentProps & ShareLinkButtonTranslations;

class ShareLinkButtonComponent extends React.PureComponent<ShareLinkButtonProps> {

  public render() {
    const {
      componentId,
      children,
      textGoToProfile,
      textNoUserEmailExist,
      searchRequired
    } = this.props;
    const userEmail = this.props.sharedState.email;
    
    const modalView = 
      <ShareLinkContext.Provider value = {{searchRequired: searchRequired, domainNoUsers: Number(componentId)}}>
        {!userEmail ? 
          <div className="alert alert-error">
            <p>{textNoUserEmailExist}</p>
            <a href={toAbsoluteUrl(routeConstants.userProfileMainView)} target="_blank" rel="noopener noreferrer">
              {textGoToProfile}
            </a>
          </div> : 
          <>
            {children}
          </>}
      </ShareLinkContext.Provider>;

    return (
      <div id={componentId} className='col-md-auto p-0'>
        <LinkToModalView content={modalView} icon={<MdShare/>} {...this.props}/>
      </div>
    );
  }
}

const c = withOpenState()(ShareLinkButtonComponent);

export { c as ShareLinkButton };
